var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2946",
    "data-name": "Trazado 2946",
    d: "M132.625,214.407l-1.643,4.154-.665-3.532a.736.736,0,0,0-.728-.622H126.9l-.037.177a6.6,6.6,0,0,1,1.558.519.668.668,0,0,1,.375.536l1.259,4.871h1.669l2.558-6.1Zm2.336,0-1.306,6.1h1.579l1.306-6.1Zm9.053,1.649.478,2.292h-1.31Zm-.231-1.649a.718.718,0,0,0-.672.448l-2.369,5.656H142.4l.329-.912h2.025l.191.912h1.46l-1.275-6.1Zm-6.813,1.906c-.01.879.784,1.369,1.382,1.661.615.3.821.491.819.758,0,.41-.491.59-.945.6a3.3,3.3,0,0,1-1.622-.386l-.286,1.337a4.786,4.786,0,0,0,1.756.324c1.659,0,2.744-.819,2.749-2.088.007-1.611-2.227-1.7-2.212-2.419.005-.219.213-.452.67-.511a2.982,2.982,0,0,1,1.557.273l.278-1.294a4.246,4.246,0,0,0-1.477-.27c-1.561,0-2.659.83-2.668,2.017",
    transform: "translate(-126.865 -214.295)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1218",
    "data-name": "Grupo 1218",
    transform: "translate(-200 -831)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_904",
    "data-name": "Rect\\xE1ngulo 904",
    width: 24,
    height: 20,
    rx: 3,
    transform: "translate(200 831)",
    fill: "#144ca5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1217",
    "data-name": "Grupo 1217",
    transform: "translate(74.656 623.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2945",
    "data-name": "Trazado 2945",
    d: "M132.625,214.407l-1.643,4.154-.665-3.532a.736.736,0,0,0-.728-.622H126.9l-.037.177a6.6,6.6,0,0,1,1.558.519.668.668,0,0,1,.375.536l1.259,4.871h1.669l2.558-6.1Zm2.336,0-1.306,6.1h1.579l1.306-6.1Zm9.053,1.649.478,2.292h-1.31Zm-.231-1.649a.718.718,0,0,0-.672.448l-2.369,5.656H142.4l.329-.912h2.025l.191.912h1.46l-1.275-6.1Zm-6.813,1.906c-.01.879.784,1.369,1.382,1.661.615.3.821.491.819.758,0,.41-.491.59-.945.6a3.3,3.3,0,0,1-1.622-.386l-.286,1.337a4.786,4.786,0,0,0,1.756.324c1.659,0,2.744-.819,2.749-2.088.007-1.611-2.227-1.7-2.212-2.419.005-.219.213-.452.67-.511a2.982,2.982,0,0,1,1.557.273l.278-1.294a4.246,4.246,0,0,0-1.477-.27c-1.561,0-2.659.83-2.668,2.017",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1216",
    "data-name": "Grupo 1216",
    transform: "translate(126.865 214.295)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_905",
    "data-name": "Rect\\xE1ngulo 905",
    width: 19.54,
    height: 6.311,
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaLogo);
export default __webpack_public_path__ + "static/media/visa-logo.4fcc9148712365595075133415f286d6.svg";
export { ForwardRef as ReactComponent };